"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
require("./CartNavMenu.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _default = _ref => {
  let {
    defaultCurrency = 'USD',
    currencies = [],
    currency = 'USD',
    setCurrency,
    settings,
    onCancel,
    onOk
  } = _ref;
  const getCurrencySymbol = currency => 0 .toLocaleString(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\w/g, "").trim();
  const CurrencyListItem = _ref2 => {
    let {
      code,
      currency,
      isDefault = false,
      isChecked = false
    } = _ref2;
    let label = `${getCurrencySymbol(code)} ${code} - ${currency}`;
    if (isDefault) {
      label += ` (${settings?.defaultLabel || 'Default'})`;
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      className: `ter-utility-nav__my-cart__menu__currency__list__item${isChecked ? ' ter-utility-nav__my-cart__menu__currency__list__item--checked' : ''}`,
      onClick: () => setCurrency(code)
    }, isChecked && /*#__PURE__*/_react.default.createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M5.99896 11.3001L3.19896 8.50006L2.26562 9.4334L5.99896 13.1667L13.999 5.16673L13.0656 4.2334L5.99896 11.3001Z",
      fill: "#0063A3"
    })), label);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-utility-nav__my-cart__menu__currency"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "ter-utility-nav__my-cart__menu__currency__title"
  }, settings?.currencyListTitle || 'Currency'), /*#__PURE__*/_react.default.createElement("ul", {
    className: "ter-utility-nav__my-cart__menu__currency__list"
  }, currencies.map((d, index) => /*#__PURE__*/_react.default.createElement(CurrencyListItem, _extends({
    key: index,
    isChecked: d.code === currency,
    isDefault: d.code === defaultCurrency
  }, d)))), settings?.currencyListText && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-utility-nav__my-cart__menu__currency__description",
    dangerouslySetInnerHTML: {
      __html: settings?.currencyListText
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-utility-nav__my-cart__menu__buttons"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-utility-nav__my-cart__menu__buttons__secondary",
    onClick: onCancel
  }, settings?.cancelLabel || 'Cancel'), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "ter-button--primary--1 ter-utility-nav__my-cart__menu__buttons__primary",
    size: "md",
    onClick: onOk
  }, settings?.submitLabel || 'OK')));
};
exports.default = _default;